"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onLogout = void 0;
var onLogout = function (callback) {
    var wrappedCallback = (function (event) { return callback(event.detail); });
    document.addEventListener('MONASDK_LOGOUT', wrappedCallback);
    return function () { return document.removeEventListener('MONASDK_LOGIN', wrappedCallback); };
};
exports.onLogout = onLogout;
exports.default = exports.onLogout;
